function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M18,19 C17.447,19 17,18.552 17,18 C17,17.448 17.447,17 18,17 C18.553,17 19,17.448 19,18 C19,18.552 18.553,19 18,19 M11,19 C10.448,19 10,18.552 10,18 C10,17.448 10.448,17 11,17 C11.552,17 12,17.448 12,18 C12,18.552 11.552,19 11,19 M4,19 C3.448,19 3,18.552 3,18 C3,17.448 3.448,17 4,17 C4.552,17 5,17.448 5,18 C5,18.552 4.552,19 4,19 M9,5 C9,3.895 9.896,3 11,3 C12.104,3 13,3.895 13,5 C13,6.104 12.104,7 11,7 C9.896,7 9,6.104 9,5 M19,15.185 L19,13 C19,11.346 17.653,10 15.999,10 L12,10 L12,8.857 C13.721,8.41 15,6.858 15,5 C15,2.794 13.206,1 11,1 C8.794,1 7,2.794 7,5 C7,6.858 8.28,8.41 10,8.857 L10,10 L5.996,10 C4.344,10 3,11.344 3,12.996 L3,15.185 C1.839,15.599 1,16.698 1,18 C1,19.654 2.346,21 4,21 C5.654,21 7,19.654 7,18 C7,16.698 6.162,15.599 5,15.185 L5,12.996 C5,12.446 5.447,12 5.996,12 L10,12 L10,15.185 C8.839,15.599 8,16.698 8,18 C8,19.654 9.346,21 11,21 C12.654,21 14,19.654 14,18 C14,16.698 13.161,15.599 12,15.185 L12,12 L15.999,12 C16.551,12 17,12.448 17,13 L17,15.185 C15.839,15.599 15,16.698 15,18 C15,19.654 16.346,21 18,21 C19.654,21 21,19.654 21,18 C21,16.698 20.161,15.599 19,15.185"
});

var SvgTeams = function SvgTeams(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 22,
      height: 22,
      viewBox: "0 0 22 22"
    }, props), _ref)
  );
};

export default SvgTeams;